import { HttpRequest } from '../../lib/http';
import { API, FORM_VALUE_INTER } from './constant';

export const sendAuthSignupData = (payload: FORM_VALUE_INTER): any => {
  return HttpRequest({
    method: API.MAIN.TYPE,
    url: API.MAIN.URL,
    data: payload,
  });
};

export const sendCodesValidationData = (payload: {
  promoId: number;
  codes: string[];
}): any => {
  return HttpRequest({
    method: API.VALIDATION.TYPE,
    url: API.VALIDATION.URL,
    data: payload,
  });
};
